export default __webpack_public_path__ + "static/media/homehistory.d1f08632.svg";